import {Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MatTab, MatTabContent, MatTabGroup} from '@angular/material/tabs';
import {UserDetailComponent} from '../user-detail/user-detail.component';
import {UserRolesComponent} from '../user-roles/user-roles.component';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'wim-user-tab-detail',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatTab,
    MatTabContent,
    MatTabGroup,
    UserDetailComponent,
    UserRolesComponent,
  ],
  templateUrl: './user-tab-detail.component.html',
  styleUrl: './user-tab-detail.component.scss'
})
export class UserTabDetailComponent {
  selectedTab: unknown;

  constructor(private route: ActivatedRoute) {
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      const selectedTab = params["tab"];
      console.log(selectedTab);
      this.selectedTab = selectedTab;
    });
  }

}
